var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScheduleCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "img-fluid",
    id: "outputsvg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "l1oOYlBisYNJhHDYOBylJ5O",
    fill: "#4aa2ea",
    style: {
      transform: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "none"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pHkqEHhpC",
    d: "M60 940 c-19 -19 -20 -33 -20 -420 0 -466 -6 -440 99 -440 57 0 59 -1 65 -30 12 -63 100 -63 112 0 l7 30 177 0 178 0 6 -30 c12 -63 100 -63 112 0 6 29 8 30 65 30 105 0 99 -26 99 440 0 387 -1 401 -20 420 -19 19 -33 20 -440 20 -407 0 -421 -1 -440 -20z m860 -330 l0 -310 -420 0 -420 0 0 310 0 310 420 0 420 0 0 -310z m0 -420 l0 -70 -59 0 c-57 0 -59 1 -65 30 -12 63 -100 63 -112 0 l-7 -30 -177 0 -177 0 -7 30 c-12 63 -100 63 -112 0 -6 -29 -8 -30 -65 -30 l-59 0 0 70 0 70 420 0 420 0 0 -70z m-640 -90 c0 -53 -2 -60 -20 -60 -18 0 -20 7 -20 60 0 53 2 60 20 60 18 0 20 -7 20 -60z m480 0 c0 -53 -2 -60 -20 -60 -18 0 -20 7 -20 60 0 53 2 60 20 60 18 0 20 -7 20 -60z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "pLjhyvcoZ",
    d: "M200 610 l0 -230 300 0 300 0 0 230 0 230 -300 0 -300 0 0 -230z m140 140 l0 -50 -50 0 -50 0 0 50 0 50 50 0 50 0 0 -50z m140 0 l0 -50 -50 0 -50 0 0 50 0 50 50 0 50 0 0 -50z m140 0 l0 -50 -50 0 -50 0 0 50 0 50 50 0 50 0 0 -50z m140 0 l0 -50 -50 0 -50 0 0 50 0 50 50 0 50 0 0 -50z m-420 -140 l0 -50 -50 0 -50 0 0 50 0 50 50 0 50 0 0 -50z m140 0 l0 -50 -50 0 -50 0 0 50 0 50 50 0 50 0 0 -50z m140 0 l0 -50 -50 0 -50 0 0 50 0 50 50 0 50 0 0 -50z m140 0 l0 -50 -50 0 -50 0 0 50 0 50 50 0 50 0 0 -50z m-420 -140 l0 -50 -50 0 -50 0 0 50 0 50 50 0 50 0 0 -50z m140 0 l0 -50 -50 0 -50 0 0 50 0 50 50 0 50 0 0 -50z m140 0 l0 -50 -50 0 -50 0 0 50 0 50 50 0 50 0 0 -50z m140 0 l0 -50 -50 0 -50 0 0 50 0 50 50 0 50 0 0 -50z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleCalendarIcon);
export default __webpack_public_path__ + "static/media/schedule-calendar-icon.340069aeb04a2935cb780312d1fc3f62.svg";
export { ForwardRef as ReactComponent };